<template>
  <div class="package-editor">
    <el-form
      ref="packageForm"
      :model="value"
      :rules="rules"
      @submit.native.prevent
    >
      <!-- Editor Section -->
      <div class="editor-section-card">
        <div class="row">
          <!-- #region Upload Image Section -->
          <div class="col image-container">
            <div class="image-input">
              <label class="label"
                >รูปรายละเอียด Package
                <span class="required-hint">*ข้อมูลจำเป็น</span></label
              >
              <el-form-item class="image-form-item" prop="packageAlbums">
                <div v-if="modalImageUrl" class="image-package-container">
                  <div v-for="(imageUrl, index) in modalImageUrl" :key="index">
                    <img class="image-package" :src="imageUrl" />
                  </div>
                </div>
                <el-button
                  v-if="!disabled && !isDisabledByLanguageNotTH"
                  type="sc-asset-light"
                  icon="el-icon-upload"
                  @click="handleClickChooseImageButton"
                >
                  อัปโหลด
                </el-button>
              </el-form-item>
              <label class="label-image-size"
                >1,200 x 1,200 (สูงสุด 5 รูป)</label
              >
            </div>

            <div class="image-input">
              <label class="label"
                >รูป RJ Recommended
                <span class="required-hint">*ข้อมูลจำเป็น</span></label
              >
              <el-form-item class="image-form-item" prop="imageFile">
                <img
                  v-if="modalCoverImagePreviewUrl"
                  class="image"
                  :src="modalCoverImagePreviewUrl"
                />
                <el-button
                  v-if="!disabled && !isDisabledByLanguageNotTH"
                  type="sc-asset-light"
                  icon="el-icon-upload"
                  @click="handleClickChooseCoverImageButton"
                >
                  อัปโหลด
                </el-button>
              </el-form-item>
              <label class="label-image-size">1,200 x 800</label>
            </div>

            <div class="image-input">
              <label class="label"
                >รูป Thumbnail<span class="required-hint"
                  >*ข้อมูลจำเป็น</span
                ></label
              >
              <div class="thumbnail-container">
                <div>
                  <img
                    v-if="modalThumbnailUrl"
                    class="thumbnail"
                    :src="modalThumbnailUrl"
                  />
                  <el-button
                    v-if="!disabled && !isDisabledByLanguageNotTH"
                    type="sc-asset-light"
                    icon="el-icon-upload"
                    @click="handleClickChooseThumbnailButton"
                  >
                    อัปโหลด
                  </el-button>
                  <label class="label-image-size" style="color: red">
                    675 x 675
                  </label>
                </div>

                <div>
                  <img
                    v-if="modalThumbnailAdUrl && !disabled && !isDisabledByLanguageNotTH"
                    id="button-remove-picture"
                    src="/static/icons/cancel-black.svg"
                    class="btn-remove pointer"
                    @click="removeFile"
                  />
                  <img
                    v-if="modalThumbnailAdUrl"
                    class="thumbnail"
                    :src="modalThumbnailAdUrl"
                  />
                  <el-button
                    v-if="!disabled && !isDisabledByLanguageNotTH"
                    type="sc-asset-light"
                    icon="el-icon-upload"
                    @click="handleClickChooseThumbnailAdUrlButton"
                  >
                    อัปโหลด
                  </el-button>
                  <label class="label-image-size">675 x 1,200</label>
                </div>
              </div>
            </div>

            <div class="image-input mb-3">
              <label class="label">Upload ภาพรายละเอียด</label>
              <div v-if="modalDetailImageUrl" class="image-package-container">
                <div
                  v-for="(imageUrl, index) in modalDetailImageUrl"
                  :key="index"
                >
                  <img class="image-package-v2" :src="imageUrl" />
                </div>
              </div>
              <el-button
                v-if="!disabled && !isDisabledByLanguageNotTH"
                type="sc-asset-light"
                icon="el-icon-upload"
                @click="handleClickChooseDetailImageButton"
              >
                อัปโหลด
              </el-button>
              <label class="label-image-size"
                >กว้่าง 1,200 px (สูงสุด 5 รูป)</label
              >

              <label class="label">ลำดับการแสดงผลบนหน้าผลิตภัณฑ์</label>
              <div
                class="radio-group"
                :class="{ disabled: disabledAndCheckLanguageNotTH }"
              >
                <label
                  v-for="option in detailImagesPositionOptions"
                  :key="option.value"
                  class="select-input"
                  :class="{ disabled: disabledAndCheckLanguageNotTH }"
                >
                  <span>{{ option.label }}</span>
                  <input
                    v-model="value.detailImagesPosition"
                    type="radio"
                    :value="option.value"
                    :disabled="disabledAndCheckLanguageNotTH"
                  />
                  <span class="checkmark radio"></span>
                </label>
              </div>
            </div>
          </div>
          <!-- #endregion -->

          <!-- Editor Section -->
          <div class="col info-editor">
            <div v-if="id" class="row mb-2 ri-button-section">
              <label class="label mt-2">ชื่อ (ID: {{ id }})</label>
              <ri-link-button
                class="ml-2"
                :link="ruejaiIntelligenceLink"
              ></ri-link-button>
            </div>
            <label v-else class="label"
              >ชื่อ <span class="required-hint">*ข้อมูลจำเป็น</span></label
            >
            <el-form-item prop="name">
              <el-input
                class="input"
                :value="name"
                :disabled="disabled"
                @input="handleChangeInput('name', $event)"
              ></el-input>
            </el-form-item>

            <!-- #region Receipt section -->
            <label class="label">ชื่อที่แสดงในใบเสร็จ/ใบกำกับภาษี</label>
            <div>
              <el-checkbox
                v-model="isNotSendReceipt"
                :disabled="isDisabledByLanguageNotTH"
                >ไม่ส่งใบเสร็จ</el-checkbox
              >
            </div>
            <el-input
              class="input"
              :value="receiptName"
              :disabled="disabledAndCheckLanguageNotTH || isNotSendReceipt"
              @input="handleChangeInput('receiptName', $event)"
            ></el-input>
            <!-- #endregion -->

            <!-- #region Keywords and Labels section -->
            <div style="display: flex; gap: 16px; align-items: flex-start">
              <div style="flex: 1">
                <label class="label"
                  >Keyword ค้นหาหน้า app (keywordคั่นด้วย , )</label
                >
                <el-input
                  class="input"
                  :value="keywords"
                  :disabled="disabledAndCheckLanguageNotTH"
                  @input="handleChangeInput('keywords', $event)"
                ></el-input>
              </div>

              <div style="flex: 1">
                <label-selector
                  :value="labelIds"
                  :disabled="disabledAndCheckLanguageNotTH"
                  :language="currentLanguage"
                  @input="handleChangeInput('labelIds', $event)"
                ></label-selector>
              </div>
            </div>
            <!-- #endregion -->

            <!-- #region Details section-->
            <label class="label"
              >รายละเอียด <span class="required-hint">*ข้อมูลจำเป็น</span></label
            >
            <el-form-item prop="detail">
              <div ref="editor" class="editor" :disabled="disabled"></div>
            </el-form-item>
            <!-- #endregion -->

            <!-- #region Terms ans cond section-->
            <label class="label"
              >เงื่อนไขการใช้บริการ
              <span class="required-hint">*ข้อมูลจำเป็น</span></label
            >
            <el-form-item prop="termsAndConditions">
              <div ref="term_editor" class="editor" :disabled="disabled"></div>
            </el-form-item>
            <!-- #endregion -->

            <!-- ประเภทแพ็กเกจ -->
            <div class="mb-3">
              <label class="label">ประเภทแพ็กเกจ</label>
              <div class="package-type-row">
                <div
                  class="radio-group"
                  :class="{
                    disabled:
                      disabledAndCheckLanguageNotTH || value.isReadonlyPackage,
                  }"
                >
                  <label
                    class="select-input"
                    :class="{
                      disabled:
                        disabledAndCheckLanguageNotTH ||
                        value.isReadonlyPackage,
                    }"
                  >
                    <span>แพ็กเกจ One time</span>
                    <input
                      v-model="packageType"
                      type="radio"
                      value="onetime"
                      :disabled="
                        disabledAndCheckLanguageNotTH || value.isReadonlyPackage
                      "
                    />
                    <span class="checkmark radio"></span>
                  </label>

                  <label
                    class="select-input"
                    :class="{
                      disabled:
                        disabledAndCheckLanguageNotTH ||
                        value.isReadonlyPackage,
                    }"
                  >
                    <span>แพ็กเกจ Subscription</span>
                    <input
                      v-model="packageType"
                      type="radio"
                      value="subscription"
                      :disabled="
                        disabledAndCheckLanguageNotTH || value.isReadonlyPackage
                      "
                    />
                    <span class="checkmark radio"></span>
                  </label>
                </div>

                <div class="package-type-detail">
                  <label class="">รอบตัดบิล</label>
                  <el-input
                    class="input"
                    :disabled="
                      disabledAndCheckLanguageNotTH || packageType === 'onetime'
                    "
                    :value="billingCycle"
                    :readonly="value.isReadonlyPackage"
                    type="number"
                    min="0"
                    @input="handleChangeInput('billingCycle', $event)"
                  ></el-input>
                  <label class="">เดือน</label>
                </div>
              </div>
            </div>

            <!-- #region Purchasing section -->
            <div class="row mb-3">
              <div class="col-4">
                <label class="label">จำกัดสิทธิ์การซื้อ</label>
                <el-select
                  v-model="purchasingLimit"
                  class="input"
                  placeholder="ไม่จำกัดสิทธิ์"
                  :disabled="isDisabledByLanguageNotTH"
                  clearable
                >
                  <el-option
                    v-for="option in purchasingLimitOptions"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                    >{{ option.label }}</el-option
                  >
                </el-select>
              </div>

              <!-- minimum quantity -->
              <div class="col-4">
                <label class="label">จำนวนที่ซื้อได้ต่ำสุด</label>
                <el-input
                  type="number"
                  min="1"
                  :value="value.minimumQuantity"
                  :disabled="disabledAndCheckLanguageNotTH"
                  @input="handleChangeInput('minimumQuantity', $event)"
                ></el-input>
              </div>

              <!-- maximum quantity -->
              <div class="col-4">
                <label class="label"
                  >จำนวนที่ซื้อได้สูงสุด
                  <span class="required-hint">*ข้อมูลจำเป็น</span></label
                >
                <el-form-item prop="maximumQuantity">
                  <el-input
                    type="number"
                    min="1"
                    :value="value.maximumQuantity"
                    :disabled="disabledAndCheckLanguageNotTH"
                    @input="handleChangeInput('maximumQuantity', $event)"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <!-- #endregion -->

            <!-- แพ็กเกจใหญ่ -->
            <div class="mb-3">
              <!-- Package Collection -->
              <div class="pr-3">
                <label class="label"
                  >แพ็กเกจใหญ่
                  <span class="required-hint">*ข้อมูลจำเป็น</span></label
                >
                <el-form-item prop="collectionIds">
                  <el-select
                    v-model="collectionIds"
                    class="collection"
                    placeholder="เลือกแพ็กเกจใหญ่"
                    :disabled="disabledAndCheckLanguageNotTH"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="option in collectionOptions"
                      :key="option.value"
                      :value="option.value"
                      :label="option.label"
                      >{{ option.label }}</el-option
                    >
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="row mb-3">
              <!-- Package Group -->
              <div class="col-6 pr-3">
                <label class="label"
                  >กลุ่มแพ็กเกจ
                  <span class="required-hint">*ข้อมูลจำเป็น</span></label
                >
                <el-form-item prop="packageGroupIds">
                  <el-select
                    v-model="packageGroupIds"
                    class="packageGroup"
                    placeholder="เลือกกลุ่มแพ็กเกจ"
                    :disabled="disabledAndCheckLanguageNotTH"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="option in packageGroupOptions"
                      :key="option.value"
                      :value="option.value"
                      :label="option.label"
                      >{{ option.label }}</el-option
                    >
                  </el-select>
                </el-form-item>
              </div>

              <!-- Seller Trade Party -->
              <div class="col-6">
                <label class="label"
                  >ผู้จัดหาบริการ<span class="required-hint"
                    >*ข้อมูลจำเป็น</span
                  ></label
                >
                <el-form-item prop="sellerTradePartyId">
                  <el-select
                    v-model="sellerTradePartyId"
                    class="sellerTradeParty"
                    placeholder="เลือกผู้จัดหาบริการ"
                    :disabled="disabledAndCheckLanguageNotTH"
                  >
                    <el-option
                      v-for="option in sellerTradePartyOptions"
                      :key="option.value"
                      :value="option.value"
                      :label="option.label"
                      >{{ option.label }}</el-option
                    >
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="package-lifetime">
              <label class="label">อายุการใช้งานของแพ็กเกจ</label>
              <el-checkbox
                v-model="isTemporaryPackage"
                :disabled="disabledAndCheckLanguageNotTH"
              >
                แพ็กเกจนี้สามารถสมัครหรือต่ออายุได้จนถึงวันที่
                <date-picker
                  v-model="expiredDate"
                  class="input"
                  type="date"
                  :disabled="!isTemporaryPackage || disabledAndCheckLanguageNotTH"
                ></date-picker>
              </el-checkbox>
              <el-checkbox
                v-model="value.isExpireAfterAppointment"
                :disabled="disabledAndCheckLanguageNotTH"
                >นับจากนัดหมายครั้งที่1</el-checkbox
              >
            </div>
            <div></div>

            <!-- Advance Notice Duration -->
            <div class="mb-3">
              <label class="label">แจ้งเตือนล่วงหน้าก่อนหมดอายุ</label>
              <div class="advance-notice-row">
                <el-checkbox
                  v-model="value.hasAdvanceNotice"
                  :disabled="disabledAndCheckLanguageNotTH"
                >
                  ต้องการแจ้งเตือน ก่อนหมดอายุ
                </el-checkbox>
                <el-input
                  class="input-amount"
                  type="number"
                  min="1"
                  :value="value.advanceNoticeDuration"
                  :disabled="!value.hasAdvanceNotice || disabledAndCheckLanguageNotTH"
                  @input="handleChangeInput('advanceNoticeDuration', $event)"
                ></el-input>
                <span>วัน</span>
                <el-input
                  v-model="value.advanceNoticeMessage"
                  class="input advance-notice-message"
                  placeholder="ระบุข้อความแจ้งเตือน"
                  :disabled="!value.hasAdvanceNotice || disabledAndCheckLanguageNotTH"
                  @input="handleChangeInput('advanceNoticeMessage', $event)"
                ></el-input>
              </div>
            </div>
            <!-- 
        * [RJAPP-6698] Enable only if RueJai Payment Gateway already support SC Able merchant

        <div v-if="!billingCycle" class="checkbox-container">
          <label class="label">รายการผ่อนชำระ</label>
          <el-checkbox-group v-model="value.paymentCampaignIds">
            <el-checkbox
              v-for="campaign in paymentCampaignsWithSelection"
              :key="campaign.id"
              :label="campaign.id"
              v-model="campaign.isChecked"
            >
              <img :src="campaign.bank_logo_url" width="20" height="20" />
              <span style="margin-left: 5px"></span>
              <span style="font-weight: bold">{{ campaign.bank_name }}</span>
              {{ campaign.name }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        -->
          </div>
        </div>

        <!-- #region Other Options Section -->
        <div class="other-options-card">
          <div
            class="other-options-header"
            @click="isOtherOptionsExpanded = !isOtherOptionsExpanded"
          >
            <i class="el-icon-setting"></i>
            <span>ตั้งค่าหัวข้ออื่นๆ</span>
            <i
              :class="
                isOtherOptionsExpanded
                  ? 'el-icon-arrow-up'
                  : 'el-icon-arrow-down'
              "
            ></i>
          </div>

          <div v-show="isOtherOptionsExpanded" class="other-options-grid">
            <div v-show="hasSuperPack" class="other-options-item full-width">
              <pre>เป็น Sub Package ของ</pre>
              <el-button
                v-for="(superpack, index) in value.superpackages"
                :key="index"
                round
                size="mini"
                :disabled="disabledAndCheckLanguageNotTH"
                @click="handleClickSubPack(superpack)"
              >
                {{ superpack }}
              </el-button>
            </div>

            <div v-show="!hasSuperPack" class="other-options-item">
              <label class="option-heading">หัวข้อการสั่งซื้อสำเร็จ</label>
              <el-checkbox
                v-model="hasPurchaseSuccessTitle"
                :disabled="disabledAndCheckLanguageNotTH"
                >มีหัวข้อการสั่งซื้อสำเร็จ</el-checkbox
              >
              <div v-show="hasPurchaseSuccessTitle">
                <el-input
                  v-model="purchaseSuccessTitle"
                  class="input"
                  :disabled="disabledAndCheckLanguageNotTH"
                  placeholder="ระบุหัวข้อการสั่งซื้อสำเร็จ"
                ></el-input>
              </div>
            </div>

            <div class="other-options-item">
              <label class="option-heading">ข้อความหลังการสั่งซื้อสำเร็จ</label>
              <el-checkbox
                v-model="hasPurchaseSuccessMessage"
                :disabled="disabledAndCheckLanguageNotTH"
                >มีข้อความหลังการสั่งซื้อสำเร็จ</el-checkbox
              >
              <div v-show="hasPurchaseSuccessMessage">
                <el-input
                  v-model="purchaseSuccessMessage"
                  class="input"
                  :disabled="disabledAndCheckLanguageNotTH"
                  placeholder="ระบุข้อความหลังการสั่งซื้อสำเร็จ"
                ></el-input>
              </div>
            </div>

            <div class="other-options-item">
              <label class="option-heading">หัวข้อหมายเหตุ</label>
              <el-checkbox
                v-model="hasNoteLabel"
                :disabled="disabledAndCheckLanguageNotTH"
                >มีหัวข้อหมายเหตุ</el-checkbox
              >
              <div v-show="hasNoteLabel">
                <el-input
                  v-model="value.noteLabel"
                  class="input"
                  :disabled="disabledAndCheckLanguageNotTH"
                  placeholder="ระบุหัวข้อหมายเหตุ"
                  @input="handleChangeInput('noteLabel', $event)"
                ></el-input>
              </div>
            </div>

            <div v-show="!hasSuperPack" class="other-options-item">
              <label class="option-heading">Parent Package</label>
              <el-checkbox
                v-model="hasPackageCollection"
                :disabled="disabledAndCheckLanguageNotTH"
                >เป็น Parent Package</el-checkbox
              >
              <div v-show="hasPackageCollection">
                <el-input
                  v-model="value.packageCollection"
                  class="input"
                  :disabled="disabledAndCheckLanguageNotTH"
                  placeholder="ระบุ Package ID"
                  @input="handleChangeInput('packageCollection', $event)"
                ></el-input>
                <el-button
                  v-for="(subpack, index) in value.subpackages"
                  :key="index"
                  round
                  size="mini"
                  :disabled="disabledAndCheckLanguageNotTH"
                  @click="handleClickSubPack(subpack)"
                >
                  {{ subpack }}
                </el-button>
              </div>
            </div>

            <div class="other-options-item">
              <label class="option-heading">การซื้อครั้งแรก</label>
              <el-checkbox
                v-model="value.isIgnoreCountCoupon"
                :disabled="disabled || isDisabledByEditPackage"
                >ไม่นับการซื้อครั้งแรก</el-checkbox
              >
            </div>

            <div class="other-options-item full-width">
              <label class="option-heading">Registration Form</label>
              <el-checkbox
                v-model="hasRegistrationForm"
                :disabled="disabledAndCheckLanguageNotTH"
                >มี Registration Form</el-checkbox
              >
              <template v-if="hasRegistrationForm">
                <package-extra-editor
                  v-model="registrationForm"
                  :disabled="disabledAndCheckLanguageNotTH"
                ></package-extra-editor>
              </template>
            </div>
          </div>
        </div>
        <!-- #endregion -->
      </div>

      <!-- Service Selector -->
      <div class="service-selector-card">
        <label class="label"
          >รายการบริการ <span class="required-hint">*ข้อมูลจำเป็น</span></label
        >
        <service-selector
          class="input"
          :value="services"
          :disabled="disabled || value.isReadonlyPackage"
          @input="handleChangeInput('services', $event)"
        ></service-selector>
      </div>

      <!-- Package Selector -->
      <div class="package-selector-card">
        <div class="mb-3">
          <label class="label"
            >ประเภทแพ็กเกจ
            <span v-if="hasBothPackageSelectorTypes" class="required-hint"
              >*แพ็กเกจนี้เป็นแพ็กเกจโครงการและแพ็กเกจ per unit</span
            ></label
          >
          <div
            class="radio-group"
            :class="{ disabled: disabledPackageSelectorType }"
          >
            <label
              class="select-input"
              :class="{ disabled: disabledPackageSelectorType }"
            >
              <span>แพ็กเกจโครงการ</span>
              <input
                v-model="packageSelectorType"
                type="radio"
                value="project"
                :disabled="disabledPackageSelectorType"
              />
              <span class="checkmark radio"></span>
            </label>

            <label
              class="select-input"
              :class="{ disabled: disabledPackageSelectorType }"
            >
              <span>แพ็กเกจ per unit</span>
              <input
                v-model="packageSelectorType"
                type="radio"
                value="perUnit"
                :disabled="disabledPackageSelectorType"
              />
              <span class="checkmark radio"></span>
            </label>
          </div>
        </div>

        <div v-if="packageSelectorType === 'project'" class="mb-3">
          <project-province-selector
            :disabled="disabledAndCheckLanguageNotTH"
            :value="projects"
            :lock-previously-selected="false"
            @allProject="allProject"
            @input="handleChangeInput('projects', $event)"
          ></project-province-selector>
        </div>

        <div v-else class="mb-3">
          <label class="label">บ้านที่รองรับ (Per Unit)</label>
          <el-autocomplete
            v-model="searchHomeText"
            class="home-search-input"
            :fetch-suggestions="projectQuerySearch"
            placeholder="ค้นหาโครงการ / บ้านเลขที่ / รหัสโครงการ"
            :trigger-on-focus="false"
            :disabled="disabledAndCheckLanguageNotTH"
            @select="handleSelectHome"
          >
            <template slot-scope="{ item }">
              <div class="user">
                <div class="home">{{ item.address_no }}</div>
                <div class="home">
                  {{ item.project.project_name }} ({{
                    item.project.project_code
                  }})
                </div>
              </div>
            </template>
          </el-autocomplete>
          <div v-if="homes && homes.length > 0" class="home-box">
            <p class="label count">
              บ้านที่รองรับจำนวน {{ homes.length }} หลัง
            </p>
            <div
              v-for="(home, index) in homes"
              :key="index"
              class="user-list-item"
            >
              <div class="user">
                <div class="home">{{ home.address_no }}</div>
                <div class="home">
                  {{ home.project.project_name }} ({{ home.project_code }})
                </div>
              </div>
              <button
                v-if="!disabled && !isDisabledByLanguageNotTH"
                class="btn-delete"
                @click="handleClickDeleteHome(home.home_id)"
              >
                <img src="/static/icons/trash.svg" :alt="$t('label.delete')" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Pricing -->
      <div class="pricing-card">
        <div class="mb-3">
          <label class="label">ประเภทราคา</label>
          <div
            class="radio-group"
            :class="{ disabled: disabledAndCheckLanguageNotTH }"
          >
            <label
              class="select-input"
              :class="{ disabled: disabledAndCheckLanguageNotTH }"
            >
              <span>ราคาปกติ</span>
              <input
                v-model="hasDiscountPromotion"
                type="radio"
                :value="false"
                :disabled="disabledAndCheckLanguageNotTH"
              />
              <span class="checkmark radio"></span>
            </label>

            <label
              class="select-input"
              :class="{ disabled: disabledAndCheckLanguageNotTH }"
            >
              <span>จัดโปรโมชั่นลดราคา</span>
              <input
                v-model="hasDiscountPromotion"
                type="radio"
                :value="true"
                :disabled="disabledAndCheckLanguageNotTH"
              />
              <span class="checkmark radio"></span>
            </label>
          </div>
        </div>

        <div class="row mb-3 pricing-row">
          <div class="col">
            <label class="label"
              >ราคา (บาท) <span class="required-hint">*ข้อมูลจำเป็น</span></label
            >
            <el-form-item
              :prop="hasDiscountPromotion ? 'originalPrice' : 'price'"
            >
              <el-input
                class="input"
                placeholder="ระบุราคา"
                :disabled="disabledAndCheckLanguageNotTH"
                :value="hasDiscountPromotion ? originalPrice : price"
                type="number"
                min="0"
                @input="handleChangePriceInput"
              ></el-input>
            </el-form-item>
          </div>

          <div class="col">
            <label class="label"
              >ลดแล้วเหลือ (บาท) -
              <small>ระบบจะทำการ<strong>ตัดเงิน</strong>ลูกค้าจากยอดนี้</small>
              <span class="required-hint">*ข้อมูลจำเป็น</span></label
            >
            <el-form-item prop="discountedPrice">
              <el-input
                class="input"
                :disabled="
                  disabledAndCheckLanguageNotTH || !hasDiscountPromotion
                "
                :value="price"
                type="number"
                min="0"
                @input="handleChangeInput('price', $event)"
              ></el-input>
            </el-form-item>
          </div>
        </div>

        <div v-if="packageOptions" class="mb-3">
          <label class="label">การตั้งค่าสำหรับทุกตัวเลือกสินค้า</label>
          <package-option-price-editor
            class="input"
            :value="packageOptions"
            :disabled="disabledAndCheckLanguageNotTH"
          ></package-option-price-editor>
        </div>

        <div>
          <label class="label">MNC</label>
          <div class="mnc-options">
            <div class="mnc-option">
              <label class="select-input">
                <span>ไม่ใช้ MNC เป็นส่วนลด</span>
                <input
                  v-model="coinAmountStatus"
                  type="radio"
                  value="no"
                  name="coinAmountStatus"
                  :disabled="disabledAndCheckLanguageNotTH"
                />
                <span class="checkmark radio"></span>
              </label>
            </div>
            <div class="mnc-option">
              <label class="select-input">
                <span>ใช้ MNC ลดเป็น (เปอร์เซ็นต์)</span>
                <input
                  v-model="coinAmountStatus"
                  type="radio"
                  value="percent"
                  name="coinAmountStatus"
                  :disabled="disabledAndCheckLanguageNotTH"
                />
                <span class="checkmark radio"></span>
              </label>
              <el-form-item class="mnc-input-item" prop="coinAmountPercent">
                <el-input
                  class="input"
                  :disabled="disabledCoinAmountPercent"
                  :value="coinAmountPercent"
                  type="number"
                  min="0"
                  max="100"
                  @input="handleChangeInput('coinAmountPercent', $event)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="mnc-option">
              <label class="select-input">
                <span>ใช้ MNC ลดเป็น (บาท)</span>
                <input
                  v-model="coinAmountStatus"
                  type="radio"
                  value="fix"
                  name="coinAmountStatus"
                  :disabled="disabledAndCheckLanguageNotTH"
                />
                <span class="checkmark radio"></span>
              </label>
              <el-form-item class="mnc-input-item" prop="coinAmountFix">
                <el-input
                  v-model.number="coinAmountFix"
                  class="input"
                  :disabled="disabledCoinAmountFix"
                  type="number"
                  min="0"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <!-- image modal -->
    <image-picker-modal
      v-bind="chooseCoverImageDialog"
      @cancel="handleCancelSelectCoverImageDialog"
      @confirm="handleConfirmChooseCoverImageDialog"
    ></image-picker-modal>
    <album-and-swipe-picker
      v-bind="selectImageAlbumDialog"
      @cancel="handleCancelSelectAlbumDialog"
      @confirm="handleConfirmSelectAlbumDialog($event)"
    ></album-and-swipe-picker>

    <!-- detail image -->
    <album-and-swipe-picker
      v-bind="selectDetailImageAlbumDialog"
      @cancel="handleCancelSelectDetailAlbumDialog"
      @confirm="handleConfirmSelectDetailAlbumDialog($event)"
    ></album-and-swipe-picker>

    <!-- thumbnail modal -->
    <image-picker-modal
      v-bind="chooseThumbnailDialog"
      @cancel="handleCancelChooseThumbnailDialog"
      @confirm="handleConfirmChooseThumbnailDialog"
    ></image-picker-modal>
    <image-picker-modal
      v-bind="chooseThumbnailAdUrlDialog"
      @cancel="handleCancelChooseThumbnailAdUrlDialog"
      @confirm="handleConfirmChooseThumbnailAdUrlDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import Quill from "quill";
import "quill/dist/quill.snow.css";
import {
  Input,
  Select,
  Option,
  Checkbox,
  Button,
  Autocomplete,
} from "element-ui";
import { baanRueJaiClient } from "@/dependencies";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import ProjectProvinceSelector from "@/lib/components/ProjectProvinceSelector";
import ServiceSelector from "@/lib/components/ServiceSelector/ServiceSelector";
import DatePicker from "@/lib/components/DatePicker";
import { isNil } from "ramda";
import { DateTime } from "luxon";
import AlbumAndSwipePicker from "@/lib/components/AlbumAndSwipePicker";
import {
  convertStangToBathAndRoundTwoDecimal,
  convertBathToStangAndRoundTwoDecimal,
} from "@/lib/formatter";
import LabelSelector from "@/lib/components/LabelSelector";
import { localization } from "@/lib/mapper";
import RiLinkButton from "@/lib/components/RiLinkButton";
import PackageOptionPriceEditor from "./PackageOptionPriceEditor";
import PackageExtraEditor from "./PackageExtraEditor";

export default {
  components: {
    ImagePickerModal,
    ServiceSelector,
    ProjectProvinceSelector,
    PackageExtraEditor,
    DatePicker,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
    "el-button": Button,
    PackageOptionPriceEditor,
    AlbumAndSwipePicker,
    ElAutocomplete: Autocomplete,
    LabelSelector,
    RiLinkButton,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    imageUrl: {
      type: String,
      default: null,
    },
    thumbnailUrl: {
      type: String,
      default: null,
    },
    thumbnailAdUrl: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    targets: {
      type: Array,
      default: () => [],
    },
    sellerTradeParties: {
      type: Array,
      default: () => [],
    },
    packageGroups: {
      type: Array,
      default: () => [],
    },
    collections: {
      type: Array,
      default: () => [],
    },
    paymentCampaigns: {
      type: Array,
      default: () => [],
    },
    isDisabledByLanguageNotTH: {
      type: Boolean,
      default: false,
    },
    isDisabledByEditPackage: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: null,
    },
  },
  data() {
    const cache = {
      originalPrice: this.value.originalPrice,
      price: this.value.price,
      expiredAt: this.value.expiredAt,
    };

    const extraTypeOptions = [
      { value: "1", label: "ข้อความ" },
      { value: "2", label: "ข้อความยาว" },
      { value: "3", label: "รูปบัตรประชาชน" },
    ];

    const extraPrefillOptions = [
      { value: "1", label: "ชื่อ" },
      { value: "2", label: "นามสกุล" },
      { value: "3", label: "เบอร์โทรศัพท์" },
      { value: "3", label: "บัตรประชาชน / Passport" },
    ];

    const purchasingLimitOptions = [
      { value: "PER_HOME", label: "บ้านละครั้ง" },
      { value: "PER_USER", label: "คนละครั้ง" },
    ];

    const detailImagesPositionOptions = [
      { value: "TOP", label: "รูปก่อนรายละเอียด" },
      { value: "BOTTOM", label: "รายละเอียดก่อนรูป" },
    ];

    return {
      isShowModal: false,
      isShowCoverImageModal: false,
      isShowThumbnailModal: false,
      isShowThumbnailAdUrlModal: false,
      isShowSelectDetailImageAlbum: false,
      extraTypeOptions,
      extraPrefillOptions,
      purchasingLimitOptions,
      detailImagesPositionOptions,
      cache,
      isShowSelectImageAlbum: false,
      searchHomeText: "",
      detailLength: 0,
      termLength: 0,
      currentDetailLanguage: null,
      currentTermLanguage: null,
      allProjects: [],
      selectedCampaigns: [],
      isOtherOptionsExpanded: false,
    };
  },
  computed: {
    isNotSendReceipt: {
      get() {
        return !this.value.isRequiredIssueReceipt;
      },
      set(isNotSendReceipt) {
        this.$emit("input", {
          ...this.value,
          isRequiredIssueReceipt: !isNotSendReceipt,
        });
      },
    },
    rules() {
      return {
        packageAlbums: [
          {
            validator: (rule, value, callback) => {
              const hasNoAlbums =
                !this.value.packageAlbums ||
                this.value.packageAlbums.length <= 0;

              if (hasNoAlbums && !this.id) {
                callback(new Error("กรุณาใส่รูปรายละเอียด Package"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        imageFile: [
          {
            validator: (rule, value, callback) => {
              if (!this.value.imageFile && !this.imageUrl && !this.id) {
                callback(new Error("กรุณาใส่รูป RJ Recommended"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        name: [{ required: true, message: "กรุณาระบุชื่อ", trigger: "blur" }],
        detail: [
          {
            validator: (rule, value, callback) => {
              if (this.detailLength <= 1 && !this.id) {
                callback(new Error("กรุณาระบุรายละเอียด"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        termsAndConditions: [
          {
            validator: (rule, value, callback) => {
              if (this.termLength <= 1 && !this.id) {
                callback(new Error("กรุณาระบุเงื่อนไขการใช้บริการ"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        collectionIds: [
          {
            validator: (rule, value, callback) => {
              const hasNoCollections =
                !this.value.collectionIds ||
                this.value.collectionIds.length <= 0;

              if (hasNoCollections && !this.id) {
                callback(new Error("กรุณาเลือกแพ็กเกจใหญ่"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        packageGroupIds: [
          {
            validator: (rule, value, callback) => {
              const hasNoPackageGroups =
                !this.value.packageGroupIds ||
                this.value.packageGroupIds.length <= 0;

              if (hasNoPackageGroups && !this.id) {
                callback(new Error("กรุณาเลือกกลุ่มแพ็กเกจ"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        sellerTradePartyId: [
          {
            validator: (rule, value, callback) => {
              if (!this.value.sellerTradePartyId && !this.id) {
                callback(new Error("กรุณาเลือกผู้จัดหาบริการ"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        maximumQuantity: [
          {
            required: true,
            type: "number",
            min: 1,
            message: "กรุณาระบุจำนวนที่ซื้อได้สูงสุด",
            trigger: "blur",
          },
        ],
        coinAmountPercent: [
          {
            validator: (rule, value, callback) => {
              const isEmptyPercent =
                isNil(this.value.coinAmountPercent) ||
                this.value.coinAmountPercent === "";

              if (this.coinAmountStatus === "percent" && isEmptyPercent) {
                callback(new Error("กรุณาระบุเปอร์เซ็นต์ MNC"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        coinAmountFix: [
          {
            validator: (rule, value, callback) => {
              const isEmptyFix =
                isNil(this.value.coinAmountFix) ||
                this.value.coinAmountFix === "";

              if (this.coinAmountStatus === "fix" && isEmptyFix) {
                callback(new Error("กรุณาระบุจำนวนเงิน MNC"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            type: "number",
            message: "กรุณาระบุราคา",
            trigger: "blur",
          },
        ],
        originalPrice: [
          {
            required: true,
            type: "number",
            message: "กรุณาระบุราคา",
            trigger: "blur",
          },
        ],
        discountedPrice: [
          {
            validator: (rule, value, callback) => {
              if (
                this.hasDiscountPromotion &&
                (isNil(this.value.price) || this.value.price === "")
              ) {
                callback(new Error("กรุณาระบุราคาที่ลดแล้ว"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      };
    },
    target: {
      get() {
        return this.value.target;
      },
      set(target) {
        this.$emit("input", { ...this.value, target });
      },
    },
    paymentCampaignsWithSelection() {
      const campaignsWithSelection = this.paymentCampaigns || [];

      return campaignsWithSelection.map((campaign) => ({
        ...campaign,
        isChecked: this.value.paymentCampaignIds.includes(campaign.id),
      }));
    },
    hasDiscountPromotion: {
      get() {
        return typeof this.value.originalPrice === "number";
      },
      set(hasDiscountPromotion) {
        const originalPrice = hasDiscountPromotion
          ? this.value.originalPrice || this.value.price
          : undefined;

        this.$emit("input", {
          ...this.value,
          originalPrice,
          price: !hasDiscountPromotion
            ? this.value.originalPrice
            : this.value.price,
        });

        this.$refs.packageForm.clearValidate(["price", "originalPrice"]);
      },
    },
    hasPackageCollection: {
      get() {
        return !isNil(this.value.packageCollection);
      },
      set(hasPackageCollection) {
        const packageCollection = hasPackageCollection ? 0 : null;

        this.$emit("input", {
          ...this.value,
          packageCollection,
        });
      },
    },
    isExpireAfterAppointment: {
      get() {
        return this.value.isExpireAfterAppointment;
      },
      set(isExpireAfterAppointment) {
        this.$emit("input", { ...this.value, isExpireAfterAppointment });
      },
    },
    hasSuperPack: {
      get() {
        return (
          this.value.superpackages !== undefined &&
          this.value.superpackages !== null &&
          this.value.superpackages.length > 0
        );
      },
    },
    hasNoteLabel: {
      get() {
        return !isNil(this.value.noteLabel);
      },
      set(hasNoteLabel) {
        const noteLabel = hasNoteLabel ? "" : null;

        this.$emit("input", {
          ...this.value,
          noteLabel,
        });
      },
    },
    hasAdvanceNotice: {
      get() {
        return !isNil(this.value.advanceNoticeMessage);
      },
      set(hasAdvanceNotice) {
        const advanceNoticeMessage = hasAdvanceNotice ? "" : null;

        this.$emit("input", {
          ...this.value,
          advanceNoticeMessage,
        });
      },
    },
    hasAdvanceNoticeEnabled: {
      get() {
        return this.value.hasAdvanceNotice;
      },
      set(hasAdvanceNotice) {
        this.$emit("input", { ...this.value, hasAdvanceNotice });
      },
    },
    hasPurchaseSuccessTitle: {
      get() {
        return !isNil(this.value.purchaseSuccessTitle);
      },
      set(hasPurchaseSuccessTitle) {
        const purchaseSuccessTitle = hasPurchaseSuccessTitle ? "" : null;

        this.$emit("input", {
          ...this.value,
          purchaseSuccessTitle,
        });
      },
    },
    hasPurchaseSuccessMessage: {
      get() {
        return !isNil(this.value.purchaseSuccessMessage);
      },
      set(hasPurchaseSuccessMessage) {
        const purchaseSuccessMessage = hasPurchaseSuccessMessage ? "" : null;

        this.$emit("input", {
          ...this.value,
          purchaseSuccessMessage,
        });
      },
    },
    originalPrice: {
      get() {
        return this.value.originalPrice;
      },
      set(value) {
        return this.$emit("input", { ...this.value, originalPrice: +value });
      },
    },
    isTemporaryPackage: {
      get() {
        return !isNil(this.value.expiredAt);
      },
      set(isTemporaryPackage) {
        const expiredAt = isTemporaryPackage
          ? this.cache.expiredAt || DateTime.utc().setZone("utc+7").endOf("day")
          : null;

        this.$emit("input", {
          ...this.value,
          expiredAt,
        });
      },
    },
    expiredDate: {
      get() {
        if (isNil(this.value.expiredAt)) return null;

        return this.value.expiredAt.setZone("utc+7").startOf("day");
      },
      set(expiredDate) {
        this.$emit("input", {
          ...this.value,
          expiredAt: expiredDate.setZone("utc+7").endOf("day"),
        });
      },
    },
    purchaseSuccessTitle: {
      get() {
        return this.value.purchaseSuccessTitle;
      },
      set(purchaseSuccessTitle) {
        this.$emit("input", { ...this.value, purchaseSuccessTitle });
      },
    },
    purchaseSuccessMessage: {
      get() {
        return this.value.purchaseSuccessMessage || "";
      },
      set(purchaseSuccessMessage) {
        this.$emit("input", { ...this.value, purchaseSuccessMessage });
      },
    },
    optionForm: {
      get() {
        return this.value.optionForm;
      },
      set(optionForm) {
        return this.$emit("input", { ...this.value, optionForm });
      },
    },
    pricings: {
      get() {
        return this.value.pricings;
      },
      set(pricings) {
        return this.$emit("input", { ...this.value, pricings });
      },
    },
    hasRegistrationForm: {
      get() {
        return !isNil(this.value.registrationForm);
      },
      set(hasRegistrationForm) {
        this.$emit("input", {
          ...this.value,
          hasRegistrationForm,
          registrationForm: hasRegistrationForm
            ? {
                title: "",
                sections: [],
              }
            : null,
        });
      },
    },
    registrationForm: {
      get() {
        return this.value.registrationForm;
      },
      set(registrationForm) {
        return this.$emit("input", { ...this.value, registrationForm });
      },
    },
    purchasingLimit: {
      get() {
        return this.value.purchasingLimit;
      },
      set(purchasingLimit) {
        if (purchasingLimit === "") {
          return this.$emit("input", { ...this.value, purchasingLimit: null });
        }

        return this.$emit("input", { ...this.value, purchasingLimit });
      },
    },
    sellerTradePartyId: {
      get() {
        return this.value.sellerTradePartyId;
      },
      set(sellerTradePartyId) {
        return this.$emit("input", { ...this.value, sellerTradePartyId });
      },
    },
    packageGroupIds: {
      get() {
        return this.value.packageGroupIds || [];
      },
      set(packageGroupIds) {
        return this.$emit("input", { ...this.value, packageGroupIds });
      },
    },
    collectionIds: {
      get() {
        return this.value.collectionIds || [];
      },
      set(collectionIds) {
        return this.$emit("input", { ...this.value, collectionIds });
      },
    },
    packageCollection: {
      get() {
        return this.value.packageCollection;
      },
      set(packageCollection) {
        this.$emit("input", { ...this.value, packageCollection });
      },
    },
    isSecret: {
      get() {
        return this.value.isSecret;
      },
      set(isSecret) {
        this.$emit("input", { ...this.value, isSecret });
      },
    },
    isIgnoreCountCoupon: {
      get() {
        return this.value.isIgnoreCountCoupon;
      },
      set(isIgnoreCountCoupon) {
        this.$emit("input", { ...this.value, isIgnoreCountCoupon });
      },
    },
    id() {
      return this.value.id;
    },
    name() {
      return this.value.name;
    },
    keywords() {
      return this.value.keywords;
    },
    labelIds() {
      return this.value.labelIds || [];
    },
    receiptName() {
      return this.value.receiptName;
    },
    detail() {
      return this.value.detail;
    },
    price() {
      return this.value.price;
    },
    billingCycle() {
      return this.value.billingCycle;
    },
    isOneTimePurchase() {
      return this.billingCycle === 0;
    },
    packageType: {
      get() {
        return this.isOneTimePurchase ? "onetime" : "subscription";
      },
      set(packageType) {
        const billingCycle =
          packageType === "onetime" ? 0 : this.value.billingCycle || 1;

        return this.$emit("input", { ...this.value, billingCycle });
      },
    },
    packageSelectorType: {
      get() {
        if (this.value.packageSelectorType) {
          return this.value.packageSelectorType;
        }

        return (this.value.projects || []).length === 0 &&
          (this.value.homes || []).length > 0
          ? "perUnit"
          : "project";
      },
      set(packageSelectorType) {
        return this.$emit("input", { ...this.value, packageSelectorType });
      },
    },
    hasBothPackageSelectorTypes() {
      return (
        (this.value.projects || []).length > 0 &&
        (this.value.homes || []).length > 0
      );
    },
    disabledPackageSelectorType() {
      return (
        this.disabledAndCheckLanguageNotTH && !this.hasBothPackageSelectorTypes
      );
    },
    termsAndConditions() {
      return this.value.termsAndConditions;
    },
    services() {
      return this.value.services;
    },
    projects() {
      return this.value.projects;
    },
    noteLabel() {
      return this.value.noteLabel;
    },
    advanceNoticeMessage() {
      return this.value.advanceNoticeMessage;
    },
    advanceNoticeDuration() {
      return this.value.advanceNoticeDuration;
    },
    currentLanguage() {
      return this.language || localization.TH;
    },
    modalThumbnailUrl() {
      return this.chooseThumbnailDialog.thumbnailUrl;
    },
    modalThumbnailAdUrl() {
      return this.chooseThumbnailAdUrlDialog.thumbnailUrl;
    },
    modalCoverImagePreviewUrl() {
      return this.chooseCoverImageDialog.thumbnailUrl;
    },
    modalImageUrl() {
      return this.chooseImageDialog.thumbnailUrl;
    },
    modalDetailImageUrl() {
      return this.chooseDetailImageDialog.thumbnailUrl;
    },
    detailImagesPosition: {
      get() {
        return this.value.detailImagesPosition;
      },
      set(detailImagesPosition) {
        this.$emit("input", { ...this.value, detailImagesPosition });
      },
    },
    targetId() {
      if (!this.value.target) {
        return null;
      }

      return this.value.target.id;
    },
    targetOptions() {
      return this.targets;
    },
    sellerTradePartyOptions() {
      const sellerTradePartyOptions = this.sellerTradeParties.map((seller) => ({
        value: seller.id,
        label: seller.name,
      }));

      return sellerTradePartyOptions;
    },
    packageGroupOptions() {
      return (this.packageGroups || []).map((group) => ({
        value: group.id,
        label: group.name,
      }));
    },
    collectionOptions() {
      return (this.collections || []).map((collection) => ({
        value: collection.id,
        label: collection.name,
      }));
    },
    chooseImageDialog() {
      return {
        thumbnailUrl: this.value.packageAlbums,
      };
    },
    chooseDetailImageDialog() {
      return {
        thumbnailUrl: this.value.detailImageAlbums,
      };
    },
    chooseThumbnailDialog() {
      return {
        isShow: this.isShowThumbnailModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Thumbnail",
        width: 200,
        height: 200,
        recommendWidth: 675,
        recommendHeight: 675,
        thumbnailFile: this.value.thumbnailFile,
        thumbnailUrl: this.thumbnailUrl,
      };
    },
    chooseThumbnailAdUrlDialog() {
      return {
        isShow: this.isShowThumbnailAdUrlModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Thumbnail",
        width: 168.75,
        height: 300,
        recommendWidth: 675,
        recommendHeight: 1200,
        thumbnailFile: this.value.thumbnailAdFile,
        thumbnailUrl: this.thumbnailAdUrl,
      };
    },
    packageOptions: {
      get() {
        return this.value;
      },
      set(packageOptions) {
        return this.$emit("input", { ...this.value, packageOptions });
      },
    },
    chooseCoverImageDialog() {
      return {
        isShow: this.isShowCoverImageModal,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป RJ Recommended",
        width: 300,
        height: 200,
        recommendWidth: 1200,
        recommendHeight: 800,
        thumbnailFile: this.value.imageFile,
        thumbnailUrl: this.imageUrl,
      };
    },
    selectImageAlbumDialog() {
      return {
        isShow: this.isShowSelectImageAlbum,
        title: "รูปรายละเอียด Package",
        album: this.value.packageAlbums,
        canEdit: true,
        imageName: this.value.name,
        remark: {
          firstRemark: "สามารถเลื่อนตำแหน่งการแสดงผลได้",
          secondRemark: "รูปแรกจะเป็นรูปหลักของ package เสมอ",
        },
        dimension: {
          width: 300,
          height: 300,
          recommendWidth: 1200,
          recommendHeight: 1200,
        },
        titleForChooseImage: "เลือกรูปรายละเอียด Package",
        limit: 5,
      };
    },
    selectDetailImageAlbumDialog() {
      return {
        isShow: this.isShowSelectDetailImageAlbum,
        title: "Upload ภาพรายละเอียด",
        album: this.value.detailImageAlbums,
        canEdit: true,
        imageName: this.value.name,
        remark: {
          firstRemark: "สามารถเลื่อนตำแหน่งการแสดงผลได้",
        },
        dimension: {
          width: 600,
          recommendWidth: 1200,
        },
        titleForChooseImage: "เลือก Upload ภาพรายละเอียด",
        limit: 5,
        maxFileSizeMB: 2,
        isFreeSizeImage: true,
      };
    },
    disabledAndCheckLanguageNotTH() {
      return this.disabled || this.isDisabledByLanguageNotTH;
    },
    coinAmountPercent: {
      get() {
        return this.value.coinAmountPercent;
      },
      set(coinAmountPercent) {
        return this.$emit("input", { ...this.value, coinAmountPercent });
      },
    },
    coinAmountFix: {
      get() {
        return convertBathToStangAndRoundTwoDecimal(this.value.coinAmountFix);
      },
      set(coinAmountFix) {
        return this.$emit("input", {
          ...this.value,
          coinAmountFix: convertStangToBathAndRoundTwoDecimal(coinAmountFix),
        });
      },
    },
    coinAmountStatus: {
      get() {
        return this.value.coinAmountStatus;
      },
      set(coinAmountStatus) {
        return this.$emit("input", {
          ...this.value,
          coinAmountPercent: null,
          coinAmountFix: null,
          coinAmountStatus,
        });
      },
    },
    disabledCoinAmountPercent() {
      return (
        this.disabledAndCheckLanguageNotTH ||
        this.coinAmountStatus !== "percent"
      );
    },
    disabledCoinAmountFix() {
      return (
        this.disabledAndCheckLanguageNotTH || this.coinAmountStatus !== "fix"
      );
    },
    homes() {
      const { homes } = this.value;

      return homes.map((home) => {
        const homeProjectSelected =
          home.project ||
          this.allProjects.find(
            (pro) => pro.project_code === home.project_code
          );

        const homeProject = homeProjectSelected || {
          project_name: "",
          project_code: "",
        };

        return {
          ...home,
          project: homeProject,
        };
      });
    },
    ruejaiIntelligenceLink() {
      return `${process.env.RUEJAI_INTELLIGENCE_HOST}/ruejai-intelligence/packages/${this.value.id}/insights/1`;
    },
  },
  watch: {
    detail() {
      if (this.value.language !== this.currentDetailLanguage) {
        try {
          const delta = JSON.parse(this.detail);
          this.editor.setContents(delta);
        } catch (err) {
          console.log("err:", err);
          this.editor.setText(this.detail);
        }
        this.detailLength = this.editor.getLength();
        setTimeout(() => this.editor.setSelection(this.detailLength, 0), 0);
        this.currentDetailLanguage = this.value.language;
      }
    },
    termsAndConditions() {
      if (this.value.language !== this.currentTermLanguage) {
        try {
          const delta = JSON.parse(this.termsAndConditions);
          this.termEditor.setContents(delta);
        } catch (err) {
          console.log("err:", err);
          this.termEditor.setText(this.termsAndConditions);
        }
        this.termLength = this.termEditor.getLength();
        setTimeout(() => this.termEditor.setSelection(this.termLength, 0), 0);
        this.currentTermLanguage = this.value.language;
      }
    },
    disabled(disabled) {
      if (this.editor) {
        this.editor.enable(!disabled);
      }
      if (this.termEditor) {
        this.termEditor.enable(!disabled);
      }
    },
  },
  mounted() {
    this.editor = new Quill(this.$refs.editor, {
      theme: "snow",
      readOnly: this.disabled,
      formats: ["header", "bold", "underline", "link", "blockquote"],
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ["bold", "underline"],
          ["blockquote", "link"],
        ],
        keyboard: {
          bindings: {
            tab: {
              key: "Tab",
              handler: () => false,
            },
          },
        },
        clipboard: {
          matchVisual: false,
        },
      },
      bounds: this.$refs.editor,
      placeholder: "เริ่มพิมพ์ที่นี่",
    });
    this.editor.on("text-change", () => {
      const detailText = this.editor.getContents();
      const processedContent = {
        ops: detailText.ops.map((op) => {
          if (op.attributes?.header === 3) {
            return {
              ...op,
              attributes: {
                ...op.attributes,
                header: 2,
              },
            };
          }
          return op;
        }),
      };
      this.$emit("input", {
        ...this.value,
        detail: JSON.stringify(processedContent),
      });
      this.detailLength = this.editor.getLength();
    });

    this.termEditor = new Quill(this.$refs.term_editor, {
      theme: "snow",
      readOnly: this.disabled,
      formats: ["header", "bold", "underline", "link", "blockquote"],
      modules: {
        toolbar: [
          [{ header: 1 }, { header: 2 }],
          ["bold", "underline"],
          ["blockquote", "link"],
        ],
        keyboard: {
          bindings: {
            tab: {
              key: "Tab",
              handler: () => false,
            },
          },
        },
        clipboard: {
          matchVisual: false,
        },
      },
      bounds: this.$refs.term_editor,
      placeholder: "เริ่มพิมพ์ที่นี่",
    });
    this.termEditor.on("text-change", () => {
      const termText = this.termEditor.getContents();
      this.$emit("input", {
        ...this.value,
        termsAndConditions: JSON.stringify(termText),
      });
      this.termLength = this.termEditor.getLength();
    });
  },
  methods: {
    validate() {
      return this.$refs.packageForm.validate();
    },
    handleChangeInput(key, value) {
      const isNumber =
        key === "price" ||
        key === "billingCycle" ||
        key === "coinAmountPercent" ||
        key === "maximumQuantity";
      this.$emit("input", { ...this.value, [key]: isNumber ? +value : value });

      if (key === "services") {
        this.$emit("selectedService");
      }
    },
    handleChangePriceInput(value) {
      if (this.hasDiscountPromotion) {
        this.originalPrice = value;
      } else {
        this.handleChangeInput("price", value);
      }
    },
    handleClickChooseCoverImageButton() {
      this.isShowCoverImageModal = true;
    },
    handleCancelSelectCoverImageDialog() {
      this.isShowCoverImageModal = false;
    },
    handleClickChooseImageButton() {
      this.isShowSelectImageAlbum = true;
    },
    handleCancelSelectAlbumDialog() {
      this.isShowSelectImageAlbum = false;
    },
    handleClickChooseDetailImageButton() {
      this.isShowSelectDetailImageAlbum = true;
    },
    handleCancelSelectDetailAlbumDialog() {
      this.isShowSelectDetailImageAlbum = false;
    },
    handleConfirmSelectAlbumDialog(event) {
      const { allImageToAlbum, packageAlbums } = event;

      this.$emit("input", {
        ...this.value,
        packageAlbums,
        allImageToAlbum,
      });

      this.isShowSelectImageAlbum = false;
    },
    handleConfirmSelectDetailAlbumDialog(event) {
      const { packageAlbums } = event;

      this.$emit("input", {
        ...this.value,
        detailImageAlbums: packageAlbums,
      });

      this.isShowSelectDetailImageAlbum = false;
    },
    handleClickChooseThumbnailButton() {
      this.isShowThumbnailModal = true;
    },
    handleClickChooseThumbnailAdUrlButton() {
      this.isShowThumbnailAdUrlModal = true;
    },
    handleClickSubPack(id) {
      // this.$router.push({ name: "PackageDetailPage", params: { id } });
      const routeData = this.$router.resolve({
        name: "PackageDetailPage",
        params: { id },
      });
      window.open(routeData.href, "_blank");
    },
    handleCancelChooseThumbnailDialog() {
      this.isShowThumbnailModal = false;
    },
    handleConfirmChooseThumbnailDialog(file) {
      this.$emit("input", { ...this.value, thumbnailFile: file });
      this.isShowThumbnailModal = false;
    },
    handleConfirmChooseCoverImageDialog(file) {
      this.$emit("input", { ...this.value, imageFile: file });
      this.isShowCoverImageModal = false;
    },
    handleCancelChooseThumbnailAdUrlDialog() {
      this.isShowThumbnailAdUrlModal = false;
    },
    handleConfirmChooseThumbnailAdUrlDialog(file) {
      this.$emit("input", { ...this.value, thumbnailAdFile: file });
      this.isShowThumbnailAdUrlModal = false;
    },
    handleChangeTarget(targetId) {
      const foundTarget = this.targets.find((t) => t.id === targetId);

      this.$emit("input", { ...this.value, target: foundTarget });
    },
    async projectQuerySearch(queryString, cb) {
      const query = {
        text_search: queryString,
      };
      const response = await baanRueJaiClient.admin.homes.search(query);
      const {homes} = response.data.result;
      cb(homes);
    },
    handleSelectHome(item) {
      const homes = this.value.homes.concat(item);

      const uniqueHomes = Object.values(
        homes.reduce((acc, curr) => {
          acc[curr.home_id] = curr;
          return acc;
        }, {})
      );

      this.$emit("input", { ...this.value, homes: uniqueHomes });
    },
    handleClickDeleteHome(homeId) {
      const filteredHomes = this.value.homes.filter((val) => homeId !== val.home_id);
      this.$emit("input", { ...this.value, homes: filteredHomes });
    },
    allProject(projects) {
      this.allProjects = projects;
    },
    removeFile() {
      this.$emit("input", {
        ...this.value,
        thumbnailAdFile: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$breakpoint-lg: 1024px;

.package-editor {
  background-color: #f9fafb;

  .thumbnail-button {
    display: block;
    width: 100%;
  }

  .row {
    display: flex;
    flex-direction: column;

    @media (min-width: $breakpoint-lg) {
      flex-direction: row;
    }
  }

  .col {
    min-width: 0;
  }

  .el-form-item {
    margin-bottom: 0;

    &.is-error {
      margin-bottom: 22px;
    }

    &.is-error .editor .ql-toolbar,
    &.is-error .editor .ql-container {
      border-color: $danger-color;
    }

    &.image-form-item.is-error .el-form-item__content {
      border: 1px solid $danger-color;
      border-radius: 8px;
      padding: 8px;
    }

    &.mnc-input-item {
      margin-left: 12px;

      .el-input__inner {
        width: 100px;
      }
    }
  }

  .mnc-options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 24px;
    margin-top: 8px;
  }

  .mnc-option {
    display: flex;
    align-items: center;
  }
}

.image-container {
  flex: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: $breakpoint-lg) {
    flex: 0 0 420px;
    width: 420px;
  }
}

.image-package {
  width: 100%;
  border-radius: $border-radius;
  margin-bottom: 8px;
}

.image-package-v2 {
  width: 100%;
  height: 64px;
  border-radius: 8px;
  margin-bottom: 8px;
  object-fit: cover;
}

.image-package-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}

.info-editor {
  flex: none;
  width: 100%;
  max-width: 760px;

  @media (min-width: $breakpoint-lg) {
    flex: 1;
  }
}

.thumbnail-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;

  > div {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;

    .el-button {
      width: 100%;
    }
  }
}

.editor {
  overflow-y: scroll;
  max-height: calc(100vh - 200px);
  min-height: 150px;
  margin-bottom: 20px;
}

.label {
  display: block;

  line-height: 1.4;
  font-size: 1rem;
  font-weight: bold;
}

.label-image-size {
  display: block;
  font-size: 12px;
  text-align: center;
}

.advance-notice-row {
  display: flex;
  align-items: center;
  gap: 8px;

  .el-checkbox {
    white-space: nowrap;
  }

  .input-amount {
    width: 80px;
  }

  .advance-notice-message {
    flex: 1;
    margin-bottom: 0;
  }
}

.image-input {
  border: $border;
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .el-button {
    width: 100%;
  }
}

.collection,
.packageGroup,
.sellerTradeParty {
  width: 100%;
}

.input {
  margin-bottom: 20px;

  &.quota {
    width: 80px;
  }

  &-amount {
    width: 100px;
  }
}

.select {
  margin-bottom: 20px;
}

.input > textarea {
  min-height: 120px;
}

.thumbnail,
.image {
  margin-bottom: 20px;

  border-radius: $border-radius;
  width: 80%;
  align-self: center;
}

.target-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .image {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.target-select {
  width: 100%;
}

.btn-action {
  margin-top: 30px;
}

.user {
  padding: 6px 0;

  > .name {
    font-weight: bold;
  }

  > .name,
  > .home {
    line-height: 1.4;
  }

  > .home {
    color: #777;
    font-size: 12px;
    white-space: normal;
    word-break: break-word;
  }
}

.home-search-input {
  margin-bottom: 5px;
  width: 100%;
}

.user-list-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 8px 0;

  > .user {
    flex-grow: 1;
    padding: 0;
  }
}

.home-box {
  max-height: 500px;
  border: 1px solid rgb(192, 196, 204);
  overflow-y: auto;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
  border-radius: 5px;

  > .count {
    padding-top: 10px;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    background-color: #fff;
  }
}
.checkbox-container .el-checkbox {
  display: block;
  margin-bottom: 10px;
}

.btn-remove {
  position: absolute;
  width: 20px;
  height: 20px;
  z-index: 3;
  right: 56px;
  margin-top: 4px;
}

.ri-button-section {
  margin-left: 0.05rem;
}

.editor-section-card,
.service-selector-card,
.package-selector-card,
.pricing-card {
  background-color: $white;
  border: 1px solid #e0e0e0;
  border-radius: 15px;
  padding: 24px;
  margin-bottom: 24px;
}

.pricing-row {
  display: flex;
  gap: 24px;

  .col {
    flex: 1;
  }
}

.required-hint {
  color: $danger-color;
  font-weight: normal;
  font-size: 12px;
  margin-left: 4px;
}


.radio-group {
  display: flex;
  gap: 16px;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.package-type-row {
  display: flex;
  align-items: center;
  gap: 24px;
}

.package-type-detail {
  display: flex;
  align-items: center;
  gap: 8px;

  .label {
    margin-bottom: 0;
    white-space: nowrap;
  }

  .input {
    margin-bottom: 0;
    width: 100px;
  }
}

.package-lifetime {
  .el-checkbox {
    display: block;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .input {
    margin-bottom: 0;
  }
}

.other-options-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
}

.other-options-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  color: $orange;
  font-weight: bold;
  font-size: 1rem;
  user-select: none;
}

.other-options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 60px;
  row-gap: 40px;
  margin-top: 24px;

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: 1fr;
  }

  .el-checkbox {
    display: flex;
    align-items: center;
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-checkbox ::v-deep .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border-radius: 4px;
  }

  .el-checkbox ::v-deep .el-checkbox__inner::after {
    height: 9px;
    width: 4px;
    left: 6px;
    top: 2px;
  }

  .el-checkbox ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: $orange;
    border-color: $orange;
  }

  .el-checkbox ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: $orange;
  }

  .el-checkbox ::v-deep .el-checkbox__label,
  .el-checkbox ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #8492a6;
  }

  .input {
    margin-top: 12px;
    margin-bottom: 0;
  }

  .input ::v-deep .el-input__inner,
  .input ::v-deep .el-textarea__inner {
    border-radius: 6px;
  }
}

.other-options-item {
  &.full-width {
    grid-column: 1 / -1;
  }
}

.option-heading {
  display: block;
  margin-bottom: 12px;
  font-weight: bold;
}
</style>
